
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.76.278l5.965 6.05a.96.96 0 010 1.344l-5.966 6.05a.928.928 0 01-1.326 0 .96.96 0 010-1.345L11.8 7.951H.951a.95.95 0 010-1.902h10.848L7.433 1.623a.96.96 0 010-1.345.928.928 0 011.326 0z","fill":"#fff"}})])
          )
        }
      }
    